import { getAllTransferOrders, getAllWarehouseStock, getDispatchOrderByWarehouse, getDispatchOrderById, getFullfillmentOrderRows, getFullfillmentOrders, getTransferOrderById, getTransferOrderReferenceData, getTransferProducts, getWarehouseById, getWarehouseLocationsById, getWarehouseStockById, getWarehouses, getDispatchOrderReferenceData, getPickingListByDispatchOrder, getReceivingOrderByWarehouse, getReceivingOrderById, getDispatchOrderByPickingList, getCollectivePickingList, cancelDispatchOrderByPickingList, receiveProducts,  getShipmentLabelsBywarehouse, getRelocateProductsByWarehouse, getSearchStorageItem, stockCorrection, getAllProductsLocationsByWarehouse, getGetStorageItem, getDefaultReceivingStation, printProductLabel, printRelocationOrder, updateShipmentDispatchOrder, triggerSyncShipmentDispatchOrder, getInactiveDispatchOrderByWarehouse, getProductDispatchRate } from "src/core/api/apiRequests";
import useResponse from "src/core/api/useResponse";
import useRequest from "src/core/api/useRequest";
import { useEffect } from 'react';
import { useGetAllPaginatedItems } from "src/core/api/useGetAllPaginatedItems";

export const useGetWarehouseById = (id: string) => {
    const { rows } = useResponse<any>({
        requestFunction: getWarehouseById,
        values: { id },
        requestNothingOnNull: true,
        dependency: [id],
    });
    return id != null && String(rows?.WarehouseId) === String(id) ? rows : null;
};

export const useWarehouseLocations = (id: string) => {
    return useResponse<any[]>({
        requestFunction: getWarehouseLocationsById,
        values: { id },
        requestNothingOnNull: true,
        dependency: [id],
    });
};

export const useGetWarehouseLocationsById = (id: string) => {
    return useWarehouseLocations(id).rows;
};

export const useGetWarehouseStockById = (id: string | string[]) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getWarehouseStockById,
        pageSize: 1000,
        idField: "ArticleNumber",
        requestValues: id,
    });
};

export const useGetDispatchOrdersByWarehouse = (warehouseId: string | string[] | number | null | undefined, refreshKey?: unknown) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getDispatchOrderByWarehouse,
        pageSize: 500,
        idField: "DispatchOrderId",
        requestValues: warehouseId,
        refreshKey,
        shouldRequest: warehouseId != null,
    });
};

export const useGetInactiveDispatchOrdersByWarehouse = (warehouseId: string | string[] | number | null | undefined, refreshKey?: unknown, shouldRequest = true) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getInactiveDispatchOrderByWarehouse,
        pageSize: 500,
        idField: "DispatchOrderId",
        requestValues: warehouseId,
        refreshKey,
        shouldRequest: shouldRequest && warehouseId != null,
    });
};


export const useGetDispatchOrderByPickingList = (pickingListId: number | string | null, warehouseId: number | string | null) => {
    const [rows, setRequest, abort, loading, status] = useRequest({ logLevel: [] });
    useEffect(() => {
        if (pickingListId != null && warehouseId != null) setRequest(getDispatchOrderByPickingList(pickingListId, warehouseId));
    }, [pickingListId, warehouseId]);
    return { rows, abort, loading, status };
};

export const useCancelDispatchOrderByPickingList = ( pickingListid, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:cancelDispatchOrderByPickingList, values:{ pickingListid,warehouseId }, requestNothingOnNull:true, logLevel:[]});
    console.log("response", response)
    return response;
}

export const useGetCollectivePickingList = ( pickingListIds: string, warehouseId: string | number) => {
    const {rows, loading, status} = useResponse<Blob>({requestFunction:getCollectivePickingList, values:{ pickingListIds,warehouseId }, requestNothingOnNull:true, dependency:[pickingListIds, warehouseId], logLevel:[], responseType:"blob"});
    console.log("response", rows)
    return {rows, loading, status};
}

export const useGetDispatchOrderByWarehouse = (orderId: number | string | null, warehouseId: number | string | null) => {
    const [rows, setRequest, abort, loading, status] = useRequest({ logLevel: [] });
    useEffect(() => {
        if (orderId != null && warehouseId != null) setRequest(getDispatchOrderById(orderId, warehouseId));
    }, [orderId, warehouseId]);
    return { rows, abort, loading, status };
};
export const useGetShipmentLabelsByWarehouse = (shipmentId: number | string | null, warehouseId: string | number) => {
    const [rows, setRequest, abort, loading, status] = useRequest({ logLevel: [] });
    useEffect(() => { if (shipmentId != null && warehouseId != null) setRequest(getShipmentLabelsBywarehouse(shipmentId, warehouseId)); }, [shipmentId, warehouseId]);
    return { rows, abort, loading, status };
};

export const useTriggerSyncShipmentDispatchOrder = (shipmentId: number | string | null, warehouseId: string | number) => {
    return useResponse<void>({ requestFunction: triggerSyncShipmentDispatchOrder, values: { shipmentId, warehouseId }, requestNothingOnNull: true, dependency: [shipmentId, warehouseId], logLevel: [] });
};

export const useUpdateShipmentDispatchOrder = (shipmentId: number | string | null, warehouseId: string | number, data: any) => {
    return useResponse<any>({ requestFunction: updateShipmentDispatchOrder, values: { data, shipmentId, warehouseId }, requestNothingOnNull: true, dependency: [shipmentId, warehouseId, data], logLevel: [] });
};
export const usePrintRelocationOrder = ( orderId, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:printRelocationOrder, values:{ warehouseId,orderId, }, dependency:orderId, requestNothingOnNull:true});
    return response;
}

export const useGetProductDispatchRate = ( productId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getProductDispatchRate, values:{ productId }, dependency:productId, requestNothingOnNull:true});
    console.log("response useGetProductDispatchRate", response)
    return response;
}

export const useGetPickingListByDispatchOrder = (orderId:number|string|null, warehouseId:string|number) => {
    const {rows, loading, status} = useResponse<Blob>({requestFunction:getPickingListByDispatchOrder, values:{ orderId,warehouseId }, requestNothingOnNull:true, dependency:[orderId, warehouseId], responseType:"blob"});
    return {rows, loading, status};
  }

export const useGetReceivingOrdersByWarehouse = (warehouseId: string | number | null, refreshKey?: unknown) => {
    return useGetAllPaginatedItems<any>({ requestFunction: getReceivingOrderByWarehouse, pageSize: 500, idField: 'ReceivingAdviceRowId', requestValues: warehouseId, refreshKey, shouldRequest: warehouseId != null && warehouseId !== '' });
};
export const useGetDefaultReceivingStation = ( warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getDefaultReceivingStation, values:{ warehouseId }, dependency:warehouseId, requestNothingOnNull:true, logLevel:[]});
    return response;
}

export const usePrintProductLabel = ( productId: string | number) => {
    const response = useResponse<Blob>({requestFunction:printProductLabel, values:{ productId }, dependency:productId, requestNothingOnNull:true, logLevel:[],responseType:"blob"});
    return response;
}

export const useGetRelocateProductsByWarehouse = (warehouseId: string | string[] | number, refreshKey?: unknown) => {
    const response = useGetAllPaginatedItems<any>({
        requestFunction:getRelocateProductsByWarehouse, 
        pageSize:500, idField:"ProductId",
         requestValues:warehouseId, 
         refreshKey,
         
         shouldRequest:!(warehouseId == null)
        });
        console.log(response)
    return response;
};

export const useGetAllProductsLocationsByWarehouse = (warehouseId: string | string[] | number, refreshKey?: unknown) => {
    const response = useGetAllPaginatedItems<any>({
        requestFunction:getAllProductsLocationsByWarehouse, 
        pageSize:1000, idField:"WarehouseItemLocationId",
         requestValues:warehouseId, 
         refreshKey,
         
         shouldRequest:!(warehouseId == null)
        });
        console.log(response)
    return response;
};



export const useReceiveProducts = (payload: Parameters<typeof receiveProducts>[0] | null) => {
    // Receipt confirmations must come from this request, never a cached POST result.
    const [result, setRequest, abort, loading, status] = useRequest({ logLevel: ['error', 'success'] });
    useEffect(() => { if (payload) setRequest(receiveProducts(payload)); }, [payload]);
    const rows = result?.Items ?? result;
    return { rows: Array.isArray(rows) ? rows : null, abort, loading, status };
};

export const useGetReceivingOrderByWarehouse = (orderId: string | number | null, warehouseId: string | number | null) => {
    const [response, setRequest, abort, loading, status] = useRequest();
    useEffect(() => {
        if (orderId != null && orderId !== '' && warehouseId != null && warehouseId !== '') setRequest({ ...getReceivingOrderById(orderId, warehouseId), timeout: 30000 });
    }, [orderId, warehouseId]);
    return { rows: response?.Items ?? response, abort, loading, status };
};

export const useSearchStorageItem = (searchTerm: string, warehouseId: string | number) => {
    const [response, setRequest, abort, loading, status] = useRequest();
    useEffect(() => { if (searchTerm.trim() && warehouseId != null && warehouseId !== '') setRequest({ ...getSearchStorageItem(searchTerm, warehouseId), timeout: 30000 }); }, [searchTerm, warehouseId]);
    return { rows: response?.Items ?? response, abort, loading, status };
};

export const useGetStorageItem = (productId: string | number, manufacturerProductId: string | number, warehouseId: string | number) => {
    const [response, setRequest, abort, loading, status] = useRequest();
    useEffect(() => { if (productId != null && productId !== '' && warehouseId != null && warehouseId !== '') setRequest({ ...getGetStorageItem(productId, manufacturerProductId, warehouseId), timeout: 30000 }); }, [productId, manufacturerProductId, warehouseId]);
    return { rows: response?.Items ?? response, abort, loading, status };
};

export const useStockCorrection = (warehouseId: string | number, payload: Parameters<typeof receiveProducts>[0] | null) => {
    const [response, setRequest, abort, loading, status] = useRequest({ logLevel: ['error'] });
    useEffect(() => { if (payload && warehouseId != null && warehouseId !== '') setRequest({ ...stockCorrection(warehouseId, payload), timeout: 30000 }); }, [warehouseId, payload]);
    return { rows: response?.Items ?? response, abort, loading, status };
};

export const useGetAllWarehouseStock = () => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllWarehouseStock,
        pageSize: 1000,
        idField: "ArticleNumber",
    });
}

export const useWarehouses = () => {
    return useResponse<any[]>({
        requestFunction: getWarehouses,
    });
};

export const useGetWarehouses = () => {
    return useWarehouses().rows;
};

export const useGetFullfillmentOrders = (shouldRequest = true, refreshKey = 0) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getFullfillmentOrders,
        pageSize: 1000,
        idField: 'Id',
        shouldRequest,
        refreshKey,
    });
};

export const useGetFullfillmentOrderRows = (id: string, refreshKey = 0) => {
    const [response, setRequest, abort, loading, status] = useRequest({ logLevel: ['error'] });
    // Dispatch eligibility must come from the current read, never a cached command.
    useEffect(() => {
        if (id != null && id !== '') setRequest({ ...getFullfillmentOrderRows(id), timeout: 30000 });
    }, [id, refreshKey]);
    return { rows: response?.Items ?? response, abort, loading, status };
};




export const useGetAllTransferOrders = () => {
    return useGetAllPaginatedItems<any>({ requestFunction: getAllTransferOrders, pageSize: 500, idField: "OrderId" });

}

export const useLatestTransferOrders = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllTransferOrders,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}

export const useGetTransferOrderById = (id: string, dependecy?) => {
    const { rows: response } = useResponse<any>({ requestFunction: getTransferOrderById, values: { id }, requestNothingOnNull: true, dependency: [id, ...(Array.isArray(dependecy) ? dependecy : [dependecy])] });
    return id != null && String(response?.OrderId) === String(id) ? response : null;
}

export const useTransferOrderReferenceData = () => {
    const { rows, setNewValue, abort } = useResponse<any>({
        requestFunction: getTransferOrderReferenceData,
    });
    return [rows, setNewValue, abort] as [typeof rows, typeof setNewValue, typeof abort];
}

export const useDispatchOrderReferenceData = () => {
    const {rows,status} = useResponse<any>({requestFunction:getDispatchOrderReferenceData});
    
    return rows;
}

export const useGetTransferProducts = (warehouseId) => {
    const response = useGetAllPaginatedItems<any>({ requestFunction: getTransferProducts, pageSize: 500, idField: "ProductId", requestValues: warehouseId, shouldRequest: warehouseId != null && warehouseId !== "", refreshKey: warehouseId });
    return response;
}

